if ( typeof AnnouncementBar !== 'function' ) {

	class AnnouncementBar extends HTMLElement {
		constructor(){
			super();
			const block = this.closest('.announcement-block');
			const exitBtn = block ? block.querySelector('.announcement__exit') : null;
			if ( exitBtn ) {
				exitBtn.addEventListener('click', ()=>{
					document.body.classList.add('no-transitions');
					setTimeout(()=>{
						block.style.display = 'none';
						localStorage.setItem('announcement-dismissed-' + block.id, 'true');
						/* Recalculate height after dismissing */
						var section = document.getElementById('shopify-section-announcement-bar');
						if (section) {
							var remaining = section.querySelectorAll('.announcement-block:not([style*="display: none"])');
							if (remaining.length === 0) {
								document.body.classList.remove('show-announcement-bar');
								document.documentElement.style.removeProperty('--announcement-bar-height');
							} else {
								var height = section.offsetHeight;
								document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
							}
						}
						setTimeout(()=>{
							document.body.classList.remove('no-transitions');
						}, 100);
					}, 10)
				})
			}
		}
	}

	if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
		customElements.define('announcement-bar', AnnouncementBar);
	}

}
